export const CHART_TYPES_VALUES = {
    piechartestados: "piechartestados",
    estadopagos: "estadopagos",
};